import { NSARouterMakerResult } from "namirasoft-account-react";
import { TeamsSenderLayout } from "../TeamsSenderLayout";
import { TeamsSenderEntities } from "../TeamsSenderEntities";
import { TeamsSenderRouterProps } from "../TeamsSenderRouterProps";

export interface ProviderListPageProps extends NSARouterMakerResult, TeamsSenderRouterProps { }

function ProviderListPage(props: ProviderListPageProps)
{
	return (
		<TeamsSenderLayout {...props}
			action={{
				description: "This section displays all Teams providers you have created with their basic information.",
			}}
			pages={{
				entity: TeamsSenderEntities.provider(props),
				list: {
					ui: {}
				}
			}}
		>
			<></>
		</TeamsSenderLayout>
	);
}

export default ProviderListPage;